import React from "react"

import styles from "./styles.module.styl"

const InputCommon = props => {
	return (
		<input
			className={`
        ${props.className || ""}
        ${styles.input}
        ${props.invalid ? styles.__invalid : ""}
     `}
			disabled={props.disabled}
			placeholder={props.placeholder}
			value={props.value}
			onChange={event => props.changeHandler(event.target.value)}
			{...props.extraProps}
		/>
	)
}
export default InputCommon
